require('bootstrap-select');
require('bootstrap-select/dist/js/i18n/defaults-pt_BR');
$.fn.selectpicker.Constructor.DEFAULTS.styleBase = '';
$.fn.selectpicker.Constructor.DEFAULTS.style ='form-control form-control-sm';
